import styled from "@emotion/styled";
import React from "react";
import { SocialIcon } from "react-social-icons";

function Footer() {
  const socialHandles = [
    "https://www.linkedin.com/in/sourabh-kumbhar-aa84031a3",
    "https://www.instagram.com/sourabh_7028/",
    "https://github.com/Sourabh2001-dec/",
  ];
  return (
    <Container>
      <div
        className="info"
        style={{
          flex: 0.8,
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          color: "#777777",
        }}
      >
        <span>Site designed & developed by Sourabh Kumbhar</span>
      </div>
      <div
        className="social-handles"
        style={{ flex: 0.2, display: "flex", justifyContent: "space-evenly" }}
      >
        {socialHandles.map((url) => (
          <SocialIcon url={url} style={{ height: "35px", width: "35px" }} />
        ))}
      </div>
    </Container>
  );
}

const Container = styled.div`
  flex: 0.09;
  margin: 0;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  vertical-align: top;
  max-width: 100vw;
  padding: 20px 130px 20px 130px;
  background: whitesmoke;
  @media (max-width: 877px) {
    padding: 20px 20px;
  }
  @media (max-width: 768px) {
    transform: translateY(19px);
    flex-direction: column;

    .info {
      flex: 1;
    }
    .social-handles {
      flex: 1;
      & > a {
        margin: 10px 10px;
      }
    }
  }
`;

export default Footer;
